<script>
import common from './common.vue';
export default {
  mixins: [common],
  data() {
    return {
      fanhuiIcon: `${this.$cdnLink}/wanXin/orangeTheme/back1.png`,
    }
  }
};
</script>
 
<style lang="scss" module>
@import "../../../assets/css/redEnvelope.scss";

.wrap {
  @include common-window();
  > header {
    position: relative;
    > span {
      font-weight: 600;
      font-style: normal;
    }
    .fanhui {
      position: absolute;
      top: -0.15rem;
      right: 0.8rem;
      width: 0.7rem;
      height: 0.7rem;
    }
  }
  > main {
    padding: 0rem 0.2rem;
    overflow-y: auto;
    > p {
      padding: 0 .6rem;
      line-height: .26rem;
      color: #F0764F;
    }
    .content{
      margin-top: 0.5rem;
    }
    .inputWrap {
      @include common-inputWrap();
      position: relative;
      z-index: 10;
      margin: 0.2rem auto;
      padding-left: .2rem;
      font-size: 0.24rem;
      > input {
        width: 3.4rem;
      }
      &.code {
        margin-bottom: 0.34rem;
        > input {
          width: 2.2rem;
        }
        .getCode {
          display: flex;
          align-items: center;
          color: $primary-color;
          border-left: 1px solid $primary-color;
          padding-left: 0.1rem;
          width: 1.2rem;
          height: 0.5rem;
          justify-content: center;
          font-size: $font-nm-1;
        }
      }
    }
    .submitBtn {
      @include common-button();
    }
  }
  &.fullScreen {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      padding: 15px 10px;
      overflow-y: auto;
      > p {
        padding: 0 15px;
        line-height: 13px;
      }
      .inputWrap {
        @include full-screen-inputWrap();
        position: relative;
        z-index: 10;
        margin: 10px auto;
        font-size: 15px;
        > input {
          width: 170px;
        }
        &.code {
          margin-bottom: 17px;
          > input {
            width: 110px;
          }
          .getCode {
            display: flex;
            align-items: center;
            color: $primary-color;
            border-left: 1px solid $primary-color;
            padding-left: 5px;
            width: 60px;
            height: 25px;
            justify-content: center;
            font-size: $font-nm;
          }
        }
      }
      .submitBtn {
        @include full-screen-button();
      }
    }
  }
}
</style>